import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { TopNav } from "./TopNav";
import { MobileNavDrawer } from "./MobileNavDrawer";
import { useReducedMotion } from "../hooks/useReducedMotion";
import { cx } from "../lib/cx";

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const reducedMotion = useReducedMotion();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: reducedMotion ? "auto" : "smooth" });
    setMobileOpen(false);
  }, [location.pathname, reducedMotion]);

  return (
    <div className={cx("app-shell", reducedMotion && "reduced-motion") }>
      <div className="app-backdrop app-backdrop-a" />
      <div className="app-backdrop app-backdrop-b" />
      <TopNav onOpenMobileNav={() => setMobileOpen(true)} />
      <MobileNavDrawer open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <main className="app-main" id="main-content">
        <Outlet />
      </main>
    </div>
  );
}
